import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import { Box, Paper, Typography } from "@mui/material";
import w1 from "../../assets/New/w1.png";
import w2 from "../../assets/New/w2.png";
import w3 from "../../assets/New/w3.png";
import w4 from "../../assets/New/w4.png";
import w5 from "../../assets/New/w5.png";

// const primaryCard = {
//   title: "Expertise & Market Knowledge",
//   desc: "Our team brings years of hands-on experience and in-depth understanding of Dubai and UAE real estate markets.",
//   icon: BusinessCenterOutlinedIcon,
// };

// const otherCards = [
//   {
//     title: "Personalized Client Service",
//     desc: "We take a client-first approach, delivering tailored solutions aligned with your goals, lifestyle, and investment vision.",
//     icon: PersonOutlineOutlinedIcon,
//   },
//   {
//     title: "Innovative Marketing & Technology",
//     desc: "From advanced digital marketing to immersive virtual tours, we leverage modern tools to maximize property value.",
//     icon: RocketLaunchOutlinedIcon,
//   },
//   {
//     title: "Integrity & Transparency",
//     desc: "Trust is the foundation of our relationships. We operate with honesty, clarity, and complete transparency.",
//     icon: VerifiedOutlinedIcon,
//   },
//   {
//     title: "Long-Term Value & Relationships",
//     desc: "We focus on building lasting partnerships that grow with you over time, not just closing deals.",
//     icon: HandshakeOutlinedIcon,
//   },
// ];

const primaryCard = {
  title: "Expertise & Market Knowledge",
  image: w1,
};

const otherCards = [
  {
    title: "Personalized Client Service",
    image: w2,
  },
  {
    title: "Innovative Marketing & Technology",
    image: w3,
  },
  {
    title: "Integrity & Transparency",
    image: w4,
  },
  {
    title: "Long-Term Value & Relationships",
    image: w5,
  },
];


const iconStyle = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(207,172,106,0.12)", // soft gold
  color: "var(--color-gold)",
  mb: 2,
};

function ImageCard({ title, image, height = 260 }) {
  return (
    <Box
      sx={{
        position: "relative",
        height,
        borderRadius: "18px",
        overflow: "hidden",
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        cursor: "pointer",
        transition: "all 0.35s ease",
        "&:hover": {
          transform: "translateY(-6px)",
          boxShadow: "0 25px 60px rgba(0,0,0,0.25)",
        },
      }}
    >
      {/* DARK GRADIENT */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.05), rgba(0,0,0,0.65))",
        }}
      />

      {/* TITLE */}
      <Typography
        sx={{
          position: "absolute",
          bottom: 20,
          left: 20,
          right: 20,
          color: "#fff",
          fontWeight: 600,
          fontSize: 16,
          lineHeight: 1.3,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}


export default function WhyChooseVisionXNexus() {
  return (
    <Box
      sx={{
        backgroundColor: "var(--color-bg)",
        position: "relative",
        py: { xs: 4, md: 4 },
      }}
    >
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          px: { xs: 2, md: 4 },
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "0.9fr 1.1fr" },
          gap: { xs: 5, md: 8 },
        }}
      >
        {/* LEFT */}
        <Box>
          <Typography
            sx={{
              fontSize: { xs: 25, md: 30 },
              fontWeight: 600,
              mb: 1,
            }}
          >
            Why Choose{" "}
            <Box component="span" sx={{ color: "var(--color-gold)" }}>
              Vision X Nexus
            </Box>
          </Typography>

          <Typography
            sx={{
              color: "var(--color-text-muted)",
              lineHeight: 1.8,
              maxWidth: 420,
              mb: 2,
            }}
          >
            A refined, transparent, and results-driven real estate advisory
            across the UAE.
          </Typography>

          {/* PRIMARY IMAGE CARD */}
          <ImageCard
            title={primaryCard.title}
            image={primaryCard.image}
            height={300}
          />
        </Box>

        {/* RIGHT GRID */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 3,
          }}
        >
          {otherCards.map((item) => (
            <ImageCard key={item.title} title={item.title} image={item.image} />
          ))}
        </Box>
      </Box>

      {/* GOLD DIVIDER */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}
